import type { Prototype } from "../prototype-types";

export const alierHuPrototypes: Prototype[] = [
  {
    id: "ah-endcap-cover-flow",
    name: "Endcap Cover Flow",
    path: "/ah/endcap-cover-flow",
    description: "Full-screen END&#x2F;CAP year-in-review cards — hover to raise a card to the front, in a 3D stacked or flat 2D layout",
    owner: "Alier Hu",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/ah-endcap-cover-flow.png",
  },
];
